// 5-cell stat row rendered inside the hero. Cells are buttons when
// onClick is provided so users can jump to the relevant phase/page.

import type { CSSProperties } from "react";

export interface TelemetryCell {
  /** Uppercase label (e.g. "Accounts") */
  k: string;
  /** Primary value (e.g. "920") */
  v: string | number;
  /** Optional total — rendered as "/ total" suffix */
  total?: string | number;
  onClick?: () => void;
}

export function TelemetryRow({ cells }: { cells: TelemetryCell[] }): JSX.Element {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${cells.length}, 1fr)`,
        gap: 1,
        background: "rgba(255,255,255,.12)",
        borderRadius: 10,
        padding: 1,
      }}
    >
      {cells.map((c, i) => {
        const style: CSSProperties = {
          padding: "10px 14px",
          background:
            "linear-gradient(180deg, rgba(3,45,96,.55) 0%, rgba(3,45,96,.7) 100%)",
          border: 0,
          color: "white",
          textAlign: "left",
          borderRadius:
            i === 0
              ? "9px 0 0 9px"
              : i === cells.length - 1
                ? "0 9px 9px 0"
                : 0,
          cursor: c.onClick ? "pointer" : "default",
        };
        return (
          <button
            key={c.k}
            onClick={c.onClick}
            disabled={!c.onClick}
            style={style}
          >
            <div
              style={{
                fontSize: 10,
                color: "#8BA4BE",
                textTransform: "uppercase",
                letterSpacing: ".08em",
              }}
            >
              {c.k}
            </div>
            <div style={{ fontSize: 17, fontWeight: 700, marginTop: 2 }}>
              {c.v}
              {c.total !== undefined && (
                <span
                  style={{ fontSize: 11, color: "#8BA4BE", fontWeight: 500 }}
                >
                  {" "}
                  / {c.total}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
